import { Settings } from "luxon"
import globalContext from "../../contexts/global"
import { setLanguageCode } from '../../contexts/UserContext/actions'
import i18n from '../../i18n'
import { LANG_OPTIONS } from "../../components/LangSelect"

export const changeLanguage = (newLang: string) => {
  const { locale } = LANG_OPTIONS[newLang] ?? { locale: 'is' }
  const { userContext } = globalContext.call
  const { dispatch } = userContext
  // TODO: Change language in backend
  dispatch(setLanguageCode(newLang))
  i18n.changeLanguage(newLang)
  Settings.defaultLocale = locale // changes locale globally for Luxon
}
